export default __webpack_public_path__ + "static/media/record_book.399a64a1.svg";